<ion-app>
  <ion-header [translucent]="true" *ngIf="!hideTitle">
    <ion-toolbar color="secondary">
      <!-- <ion-buttons slot="start">
        <ion-menu-button [autoHide]="false" [disabled]="false" (click)="toggleMenu()"></ion-menu-button>
      </ion-buttons> -->
      <ion-grid>
        <ion-row>
          <ion-col class="brand-name">
            <ion-title> NextGen Rodeo </ion-title>
          </ion-col>
          <ion-col class="ion-text-center">
            <ion-title>
              {{ pageTitle | async }}
            </ion-title>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-split-pane
      id="sideNav"
      contentId="main-content"
      [class.hideNav]="!showMenu"
      [disabled]="!showMenu"
      #splitPane
    >
      <ion-menu
        menuId="default"
        contentId="main-content"
        type="overlay"
        #sideMenu
      >
        <ion-content>
          <ion-list id="inbox-list">
            <ion-menu-toggle auto-hide="false">
              <!-- <ion-item id="orgTitle" lines="none">
                <ion-thumbnail slot="start" *ngIf="selectedOrg">
                  <img [alt]="selectedOrg.name" [src]="selectedOrg.logoFileName" />
                </ion-thumbnail>
                <ion-text>{{selectedOrg.name}}</ion-text>
              </ion-item>
              <a id="changeOrgLink" routerLink="/organizations">Change Organization</a> -->
              <ng-container *ngFor="let p of appPages; let i = index">
                <ion-item
                  class="parent-page"
                  routerDirection="root"
                  [routerLink]="[p.url]"
                  lines="none"
                  [detail]="p.childPages && p.navParam"
                  queryParamsHandling="preserve"
                  routerLinkActive="selected"
                >
                  <ion-icon
                    [ios]="p.icon + '-outline'"
                    [md]="p.icon + '-sharp'"
                    size="small"
                  ></ion-icon>
                  <ion-label style="margin-left: 8px;">
                    <ion-text *ngIf="p.subtitle" class="nav-subtitle">{{
                      p.subtitle
                    }}</ion-text>
                    {{ p.title }}</ion-label
                  >
                </ion-item>
                <ng-container *ngIf="p.childPages && p.showChildPages">
                  <ion-item
                    routerDirection="root"
                    [routerLink]="[child.url]"
                    [queryParams]="child.navParam"
                    queryParamsHandling="preserve"
                    routerLinkActive="selected"
                    lines="none"
                    detail="false"
                    *ngFor="let child of p.childPages"
                    class="child-page"
                  >
                    <ion-icon
                      *ngIf="child.icon"
                      slot="start"
                      [ios]="child.icon + '-outline'"
                      [md]="child.icon + '-sharp'"
                    ></ion-icon>
                    <ion-label>{{ child.title }}</ion-label>
                  </ion-item>
                </ng-container>
              </ng-container>
              <ion-item
                (click)="logout()"
                lines="none"
                detail="false"
                color="danger"
                class="ion-text-center"
                style="margin-top: 1rem; cursor: pointer"
              >
                <ion-label>Logout</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <!-- <ion-list id="labels-list">
            <ion-list-header>Labels</ion-list-header>
  
            <ion-item *ngFor="let label of labels" lines="none">
              <ion-icon slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
              <ion-label>{{ label }}</ion-label>
            </ion-item>
          </ion-list> -->
        </ion-content>
      </ion-menu>
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
  </ion-content>
  <ion-fab vertical="bottom" horizontal="start" slot="fixed" *ngIf="showFab">
    <ion-fab-button (click)="toggleMenu()">
      <ion-icon name="menu"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-app>
